import { Component, Input } from '@angular/core';
import { IHelp } from '../../shared/modules/enterprise-configuration/enterprise-configuration-data-access.service';

@Component({
  selector: 'app-help-menu-item',
  templateUrl: './help-menu-item.component.html',
  styleUrls: ['./help-menu-item.component.scss'],
})
export class HelpMenuItemComponent {
  @Input()
  public menuItem?: IHelp;
}
